import React from "react";
import { Text } from "@react-pdf/renderer";

const thaiWords = new Intl.Segmenter("th", { granularity: "word" });
const noHyphenation = (word) => [word];

// Textkit treats callback segments as hyphenated syllables. Use actual space
// glue with near-zero font size instead (textkit replaces 0 with its default),
// so Thai words can wrap without a hyphen
// or visible gaps. Keep Latin words, quotation numbers and punctuation intact.
export default function HandoverPdfText({ children, ...props }) {
  const text = React.Children.toArray(children).join("");
  const parts = text.split(/([\u0E00-\u0E7F]+)/u);
  return (
    <Text {...props} hyphenationCallback={noHyphenation}>
      {parts.map((part, index) => {
        if (!/^[\u0E00-\u0E7F]+$/u.test(part)) return part;
        const words = Array.from(thaiWords.segment(part), ({ segment }) => segment);
        return words.map((word, wordIndex) => (
          <React.Fragment key={`${index}-${wordIndex}`}>
            {wordIndex > 0 && <Text style={{ fontSize: 0.001 }}> </Text>}
            {word}
          </React.Fragment>
        ));
      })}
    </Text>
  );
}
